// @flow
import type { AsyncDispatch } from '@dpdgroupuk/redux-action-creator';
import {
  createActionTypes,
  createAsyncAction,
  createAsyncActionTypes,
} from '@dpdgroupuk/redux-action-creator';

import { apiService, fetchTimeoutHandler } from '../../services';
import { CollectionActions } from '../orm/Collection';
import { createLoadAsyncAction } from '../../utils/actionCreator';
import { getCollectionData } from '../orm/Collection/selectors';
import { getSearchCollectionByReferenceNumber } from '../../apis';

export const ACTIONS = createActionTypes('SEARCH_COLLECTION', {
  FETCH_SEARCH_COLLECTION_BY_REFERENCE: createAsyncActionTypes(
    'FETCH_SEARCH_COLLECTION_BY_REFERENCE'
  ),
  LOGIN: createAsyncActionTypes('LOGIN'),
});

export const fetchSearchCollectionByReferenceNumber = createAsyncAction(
  (referenceNumber: string, postcode: string, token?: string) =>
    fetchTimeoutHandler(
      getSearchCollectionByReferenceNumber(referenceNumber, postcode, token)
    ).then(({ data }) => data),
  ACTIONS.FETCH_SEARCH_COLLECTION_BY_REFERENCE
);

export const login = createAsyncAction(
  (collectionCode: string, postcode: string, token: string) =>
    fetchTimeoutHandler(apiService.login(collectionCode, postcode, token)).then(
      ({ data }) => data
    ),
  ACTIONS.LOGIN
);

export const fetchCollection = (collectionCode: string, token?: string) =>
  CollectionActions.fetchCollectionByCode(collectionCode, token);

export const loginAndFetchCollection = (
  collectionCode: string,
  postcode: string,
  token: string,
  getCollectionTokenFn?: () => Promise<string>
) => (dispatch: AsyncDispatch) =>
  dispatch(login(collectionCode, postcode, token)).then(async () => {
    let collectionToken;

    if (typeof getCollectionTokenFn === 'function') {
      collectionToken = await getCollectionTokenFn();
    }

    return dispatch(
      CollectionActions.fetchCollectionByCode(collectionCode, collectionToken)
    );
  });

export const fetchCacheableCollection = (
  collectionCode: string,
  token?: string
) =>
  createLoadAsyncAction(
    state => getCollectionData(state, collectionCode),
    () => fetchCollection(collectionCode, token)
  )();
